(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/marketplace/game-list/assets/javascripts/game-container.js') >= 0) return;  svs.modules.push('/components/marketplace/game-list/assets/javascripts/game-container.js');

'use strict';

const {
  useDispatch,
  useSelector
} = ReactRedux;
const {
  Game,
  GameStatus
} = svs.components.marketplace.gameList;
const {
  getGameAriaLabel
} = svs.components.marketplace.helpers.games;
const {
  GAME_BUYIN_CLOSED,
  GAME_STATUS_SOLD_OUT,
  GAME_STATUS_REFUNDED,
  GAME_STATUS_DRAW_CLOSED,
  GAME_STATUS_SUBMITTABLE
} = svs.components.marketplaceData.gamesConstants;
const {
  FractionPayment
} = svs.components.marketplace.fractionPayment;
const {
  showDialog
} = svs.components.marketplaceData.dialogWrapper.actions;
const {
  useGetGameUrl
} = svs.components.marketplace.gameList.hooks;
const {
  roles
} = svs.components.marketplaceData.auth;
const {
  ReactButton: Button
} = svs.ui;
const {
  getTeamUrl,
  getRetailUrl
} = svs.components.marketplace.helpers;
const {
  Link
} = ReactRouterDOM;
const GameContainer = _ref => {
  var _ref4;
  let {
    game,
    gameIndex,
    fromTeamList,
    gameLinkSearch,
    groupId,
    groupName,
    hasBottomBorder,
    hasNoFractionPayment,
    isListing,
    isRetail,
    location,
    offsetForLastClicked,
    role
  } = _ref;
  const {
    activatedDrawId,
    buyStop,
    containerId,
    fractions,
    status: gameStatus,
    isSoldOut,
    isSubmitted,
    productFamily,
    productName
  } = game;
  const myId = useSelector(_ref2 => {
    let {
      customerId
    } = _ref2;
    return customerId;
  });
  const isCurrentUserAuthenticated = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const fractionsCount = fractions && fractions[myId] || 0;
  const gameUrl = useGetGameUrl(game);
  const isBeforeBuyStop = buyStop && buyStop.getTime() - Date.now() > 0;
  const dispatch = useDispatch();
  let queryString = '';
  if (gameLinkSearch) {
    queryString = "?".concat(gameLinkSearch);
  } else if (location.search) {
    queryString = "?".concat(location.search);
  }
  const handlePostGameClick = e => {
    e.preventDefault();
    const diffBuyStop = new Date(buyStop).getTime() - Date.now();
    const shouldShowSubmitWarning = !isSoldOut && diffBuyStop >= 0;
    const navigateToGame = () => location.assign(gameUrl);
    if (shouldShowSubmitWarning) {
      dispatch(showDialog({
        title: 'Vill du lämna in spelet i förtid?',
        text: "\"Sista andelsk\xF6p\" har inte passerats, s\xE5 alla medlemmar kanske inte har haft chans att l\xE4gga sin insats. ".concat(fractionsCount ? "".concat(fractionsCount, " andelar \xE4r s\xE5lda") : ''),
        icon: 'nav-my-games',
        buttons: [{
          classes: {
            inverted: true
          },
          text: 'Avbryt'
        }, {
          callback: navigateToGame,
          text: 'Gå vidare'
        }]
      }));
    } else {
      navigateToGame();
    }
  };
  const shouldDisplayPayButton = () => isBeforeBuyStop && !hasNoFractionPayment && !isSoldOut && !isSubmitted;
  const renderFractionPayment = () => {
    var _ref3;
    const isEnded = role === GAME_STATUS_REFUNDED || role === GAME_STATUS_DRAW_CLOSED;
    const isCaptainOrAdmin = (_ref3 = role !== '') !== null && _ref3 !== void 0 ? _ref3 : roles.hasPermission(role, roles.PERMISSIONS.PREPARE_GAME);
    const gameIsSubmittable = gameStatus === GAME_BUYIN_CLOSED || gameStatus === GAME_STATUS_SOLD_OUT || gameStatus === GAME_STATUS_SUBMITTABLE;
    if (isEnded || !groupId || !shouldDisplayPayButton()) {
      return null;
    }
    if (gameIsSubmittable && isCaptainOrAdmin) {
      return React.createElement("div", {
        className: "game-payment"
      }, React.createElement(Button, {
        className: "btn btn-100 btn-block btn-transparent-default qa-post-game-button",
        onClick: handlePostGameClick
      }, "L\xE4mna in spelet"));
    }
    return React.createElement(FractionPayment, {
      activatedDrawId: activatedDrawId,
      className: "game-payment",
      containerId: containerId,
      game: game,
      groupId: groupId,
      hasSnackbar: false,
      isBrowseGames: true,
      isSmall: true
    });
  };
  const linkTo = isRetail ? getRetailUrl(groupId, groupName, 'spel', containerId, activatedDrawId) : getTeamUrl(groupId, groupName, 'spel', containerId, activatedDrawId);
  const product = (_ref4 = productFamily || productName) === null || _ref4 === void 0 ? void 0 : _ref4.toLowerCase();

  const LinkComponent = _ref5 => {
    let {
      children
    } = _ref5;
    const classes = ['game-link', 'qa-navigate-game', hasBottomBorder && 'game-link-bottom-border'];
    const toProps = fromTeamList ? "".concat(linkTo).concat(queryString) : {
      pathname: linkTo,
      query: gameLinkSearch || location.search,
      state: {
        internalLink: true,
        hasBackButton: true
      }
    };
    return React.createElement(Link, {
      "aria-label": getGameAriaLabel({
        game,
        groupId,
        isCurrentUserAuthenticated,
        isListing,
        isRetail
      }),
      className: classes.filter(Boolean).join(' '),
      key: "game_".concat(gameIndex),
      onClick: () => {
        svs.components.Storage.browser.set('lastClickedGame', 'marketplace', {
          activatedDrawId,
          offset: offsetForLastClicked
        });
      },
      rel: "nofollow",
      to: toProps
    }, children);
  };
  return React.createElement(React.Fragment, {
    key: activatedDrawId
  }, Boolean(game && activatedDrawId) && React.createElement("section", {
    "data-testid": "qa-game-container"
  }, React.createElement(Game, {
    game: game,
    groupId: groupId,
    isListing: isListing,
    isRetail: isRetail,
    LinkComponent: LinkComponent,
    productName: product,
    shouldScrollTo: true
  }, React.createElement(GameStatus, {
    game: game,
    gameStatus: gameStatus,
    groupId: groupId,
    isListing: isListing,
    isRetail: isRetail
  })), renderFractionPayment()));
};
GameContainer.defaultProps = {
  gameLinkSearch: '',
  hasBottomBorder: false,
  role: ''
};
setGlobal('svs.components.marketplace.gameList.GameContainer', GameContainer);

 })(window);